import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck } from 'lucide-react';
const PURCHASES = [{
  name: 'María García',
  city: 'Buenos Aires',
  combo: 'Combo 2 – Influencia Total',
  avatar: 'https://i.pravatar.cc/80?img=1'
}, {
  name: 'Carlos Rodríguez',
  city: 'Córdoba',
  combo: 'Combo 3 – Dominio Mental',
  avatar: 'https://i.pravatar.cc/80?img=12'
}, {
  name: 'Ana Martínez',
  city: 'Rosario',
  combo: 'Combo 2 – Influencia Total',
  avatar: 'https://i.pravatar.cc/80?img=5'
}, {
  name: 'Juan Pérez',
  city: 'Mendoza',
  combo: 'Combo 3 – Dominio Mental',
  avatar: 'https://i.pravatar.cc/80?img=11'
}, {
  name: 'Sofía López',
  city: 'La Plata',
  combo: 'Combo 2 – Influencia Total',
  avatar: 'https://i.pravatar.cc/80?img=9'
}, {
  name: 'Lucas Fernández',
  city: 'Mar del Plata',
  combo: 'Combo 3 – Dominio Mental',
  avatar: 'https://i.pravatar.cc/80?img=8'
}, {
  name: 'Valentina Díaz',
  city: 'Tucumán',
  combo: 'Combo 2 – Influencia Total',
  avatar: 'https://i.pravatar.cc/80?img=16'
}, {
  name: 'Diego Morales',
  city: 'Salta',
  combo: 'Combo 3 – Dominio Mental',
  avatar: 'https://i.pravatar.cc/80?img=7'
}, {
  name: 'Camila Herrera',
  city: 'Santa Fe',
  combo: 'Combo 2 – Influencia Total',
  avatar: 'https://i.pravatar.cc/80?img=20'
}, {
  name: 'Matías Ruiz',
  city: 'Neuquén',
  combo: 'Combo 3 – Dominio Mental',
  avatar: 'https://i.pravatar.cc/80?img=3'
}];
const TIME_AGO = ['Hace unos segundos', 'Hace 1 minuto', 'Hace 2 minutos', 'Hace 3 minutos', 'Hace 5 minutos'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  const [timeAgo, setTimeAgo] = useState(TIME_AGO[0]);
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    let nextTimeout: ReturnType<typeof setTimeout>;
    const showRandomPurchase = () => {
      const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      const randomTime = TIME_AGO[Math.floor(Math.random() * TIME_AGO.length)];
      setCurrentPurchase(randomPurchase);
      setTimeAgo(randomTime);
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 4500);
      const nextTime = Math.random() * 15000 + 15000;
      nextTimeout = setTimeout(showRandomPurchase, nextTime);
    };
    const initialTimeout = setTimeout(showRandomPurchase, 5000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      clearTimeout(nextTimeout);
    };
  }, []);
  return <AnimatePresence data-id="element-72">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} transition={{
      type: 'spring',
      damping: 20,
      stiffness: 300
    }} className="fixed bottom-4 left-4 z-40 bg-white border border-gray-200 rounded-xl shadow-2xl p-3.5 max-w-[320px] flex items-start gap-3" data-id="element-73">
          {/* Avatar */}
          <img src={currentPurchase.avatar} alt={currentPurchase.name} className="w-11 h-11 rounded-full object-cover border-2 border-green-500 shrink-0" data-id="element-74" />

          {/* Info */}
          <div className="flex-1 min-w-0" data-id="element-75">
            <div className="flex items-center gap-1.5 mb-0.5" data-id="element-76">
              <p className="text-sm font-bold text-gray-900 truncate" data-id="element-77">
                {currentPurchase.name}
              </p>
              <BadgeCheck className="w-4 h-4 text-blue-500 shrink-0" data-id="element-78" />
            </div>
            <p className="text-xs text-gray-500 leading-snug" data-id="element-79">
              compró{' '}
              <span className="text-yellow-600 font-semibold" data-id="element-80">
                {currentPurchase.combo}
              </span>
            </p>
            <p className="text-xs text-gray-400 leading-snug" data-id="element-81">
              desde{' '}
              <span className="font-medium text-gray-600" data-id="element-82">
                {currentPurchase.city}
              </span>
            </p>
            <div className="flex items-center gap-1.5 mt-1.5" data-id="element-83">
              <span className="flex items-center gap-1 text-[10px] text-green-600 font-bold uppercase tracking-wider" data-id="element-84">
                <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block" data-id="element-85"></span>
                Compra verificada
              </span>
              <span className="text-[10px] text-gray-300" data-id="element-86">·</span>
              <span className="text-[10px] text-gray-400" data-id="element-87">{timeAgo}</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}